export const PAGE_TRANSITION_MS = 1000
export const MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export const DISABLE_MOBILE_DRAG = true


// WEBPACK FOOTER //
// ./src/constants.js